import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { IAlertComponent, IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { CheckKeywordTargetingResult } from "@front/m19-services";

@Component({
  selector: "app-keyword-list-manager-report",
  imports: [IAlertComponent, TranslocoDirective, IButtonDirective],
  template: `
    <div class="flex flex-col gap-4" *transloco="let t">
      @if (keywordsInError.length > 0) {
        <IAlert
          [collapsable]="true"
          [isOpen]="keywordsInError.length < 10"
          type="warning"
          [title]="t('keyword-segment-modal.ignored_keywords', { count: keywordsInError.length })"
        >
          <ul>
            @for (error of keywordsInError; track error) {
              <li>
                <span class="font-medium">{{ error.keyword.targetingValue }} - </span><span>{{ t(error.reason) }}</span>
              </li>
            }
          </ul>
        </IAlert>
      }

      @if (keywordsToAdd.length > 0) {
        <IAlert
          [collapsable]="true"
          [title]="t('keyword-segment-modal.will_add_keywords', { count: keywordsToAdd.length })"
        >
          <ul>
            @for (keyword of keywordsToAdd; track keyword) {
              <li>
                <span class="font-medium">{{ keyword.targetingValue }}</span>
              </li>
            }
          </ul>
        </IAlert>
      }
      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" size="sm" (click)="close(false)">{{ t("common.cancel") }}</button>
        @if (keywordsToAdd.length > 0) {
          <button iButton size="sm" (click)="close(true)">
            {{ t("keyword-segment-modal.add_n_keywords", { count: keywordsToAdd.length }) }}
          </button>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeywordListManagerReportModalComponent {
  private readonly modalRef = inject(ModalRef);
  private readonly modalData = inject<KeywordListManagerReportModalData>(MODAL_DATA);
  private keywordCheckResults = this.modalData.keywordCheckResults;
  keywordsInError = this.keywordCheckResults.errors;
  keywordsToAdd = this.keywordCheckResults.addedKeywords;

  close(confirm: boolean) {
    this.modalRef.close(confirm);
  }
}

export interface KeywordListManagerReportModalData {
  keywordCheckResults: CheckKeywordTargetingResult;
}
